import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
import BASE_URL from "components/BaseUrl/apiConfig";
import { useHistory } from "react-router-dom";
import { deleteExpenseType } from "components/CommanMethod/Commanmethod";
import { Pencil, Eye, Trash2 } from "lucide-react";
import ExpenseChatbot from "components/Chatbot/ExpenseChatbot";

const MySwal = Swal;

const GetExpenseType = () => {
  const history = useHistory();

  useEffect(() => {
    // Check if user is not logged in (localStorage is empty)
    if (!localStorage.getItem("userData")) {
      // Redirect to the login page
      history.push("/login");
    }
  }, [history]);

  const [expenseTypes, setExpenseTypes] = useState([]);

  //get userid form loca storage
  const storedUserData = localStorage.getItem("userData");
  let userId = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
  }

  // Function to handle the delete button click
  const handleDeleteClick = (expensedescTypeId) => {
    // Show SweetAlert confirmation dialog
    MySwal.fire({
      title: "Are you sure?",
      text: "You want to delete this Expense Type.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        // If the user confirms, call the deleteExpenseType function
        deleteExpenseType(expensedescTypeId, setExpenseTypes, MySwal);
      }
    });
  };

  //Get all exepense type data
  useEffect(() => {
    const fetchExpenseTypes = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/ExpenseDescriptiontype?userid=${userId}`
        );
        const data = await response.json();
        setExpenseTypes(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchExpenseTypes();
  }, []);

  // Function to navigate to the "Add Expense Type" page
  const navigateToAddExpenseType = () => {
    history.push("/addexpensetype");
  };

  const handleEditClick = (expenseType) => {
    // Navigate to the "addexpensetype" page with the expenseType data
    history.push({
      pathname: "/addexpensetype",
      state: { expenseType: expenseType },
    });
  };

  // Function to handle the view button click
  const handleViewClick = (expenseType) => {
    // Navigate to the "/expensetypeDetails" page with the expenseType data
    history.push({
      pathname: "/expensetypeDetails",
      state: { expenseType: expenseType },
    });
  };

  const goTobuttonClick = () => {
    // Navigate to the login page
    history.push("/expenses");
  };

  return (
    <>
      <Navbar />
      <div className="cust-div" style={{ minHeight: "550px" }}>
        <div className="container mx-auto p-4">
          <div className="flex justify-between items-center mb-4 flex-wrap">
            <h1 className="text-2xl  font-bold">Expense Types</h1>
            <div>
              <button
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 mr-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                type="button"
                onClick={goTobuttonClick}
              >
                <i
                  className="fa fa-arrow-circle-left mr-1"
                  title="Go To Expenses"
                ></i>
              </button>

              <button
                onClick={navigateToAddExpenseType}
                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                type="button"
              >
                Add Expense Type
              </button>
            </div>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full min-w-full1">
              <thead>
                <tr className="border-b bg-lightBlue-500 text-white ">
                  <th className="cell py-2 px-4 font-bold text-left">
                    Expense Type
                  </th>
                  <th className="cell py-2 px-4 font-bold text-left">
                    Default Text
                  </th>
                  <th className="cell py-2 px-4 font-bold text-left">Type</th>
                  <th
                    className="cell py-2 px-4 font-bold text-left"
                    style={{ float: "inline-end" }}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {expenseTypes && expenseTypes.length > 0 ? (
                  expenseTypes.map((expenseType) => (
                    <tr
                      key={expenseType.expensedescTypeID}
                      className="hover:bg-gray-100 border-b"
                    >
                      <td className="cell py-1 px-4 text-left">
                        {expenseType.expenseTypeName}
                      </td>
                      <td className="cell py-1 px-4 text-left">
                        {expenseType.defaulttext}
                      </td>
                      <td className="cell py-1 px-4 text-left">
                        {expenseType.type}
                      </td>
                      <td className="cell py-1 px-3 flex justify-end">
                        {/* Edit */}
                        <button
                          onClick={() => handleEditClick(expenseType)}
                          className="p-1 rounded hover:bg-blue-100 text-blue-500 transition mr-1"
                          title="Edit"
                        >
                          <Pencil size={20} />
                        </button>

                        {/* View */}
                        <button
                          onClick={() => handleViewClick(expenseType)}
                          className="p-1 rounded hover:bg-green-100 text-green-500 transition mr-1"
                          title="View"
                        >
                          <Eye size={20} />
                        </button>

                        {/* Delete */}
                        <button
                          onClick={() => handleDeleteClick(expenseType.expensedescTypeID)}
                          className="p-1 rounded hover:bg-red-100 text-red-500 transition"
                          title="Delete"
                        >
                          <Trash2 size={20} />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="4"
                      className="text-center text-lg text-gray-900 mt-4"
                    >
                      No data found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    <ExpenseChatbot />
      <Footer />
    </>
  );
};

export default GetExpenseType;
